import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { fadeUp, staggerContainer, viewportOnce } from "@/lib/motion";

const FAQS = [
  {
    q: "I soldi delle prenotazioni arrivano direttamente a me, o passano prima da voi?",
    a: "Gli incassi arrivano direttamente a te: gli account restano intestati al proprietario e i pagamenti seguono i canali che già usi. Alba non trattiene i tuoi soldi — fattura soltanto la propria provvigione. È la tua cassa, sempre.",
  },
  {
    q: "Chi controlla gli account e le piattaforme del mio immobile?",
    a: "Tu. Tutti gli account — OTA, gestionale, booking engine — restano intestati a te. Alba opera come delegato autorizzato. Se un domani vuoi proseguire da solo, hai già tutto in mano.",
  },
  {
    q: "Non ho mai affittato o ho appena comprato: riuscite a partire da zero?",
    a: "Sì. Seguiamo l'apertura dalla A alla Z: CIN e normativa, SCIA e adempimenti, tassa di soggiorno, creazione degli annunci, listini e regole della casa. Ti mettiamo in regola e sul mercato senza che tu debba diventare un esperto.",
  },
  {
    q: "Posso continuare a usare la casa e bloccare le date quando voglio?",
    a: "Certo. Il calendario resta tuo: blocchi liberamente le date che vuoi tenere per te o per famiglia e amici. Le concordiamo insieme e il resto lo mettiamo a reddito.",
  },
  {
    q: "Faccio già da solo o ho un gestore: cosa cambia con voi di concreto?",
    a: "Lavoriamo sui dati, non sulle sensazioni. Spesso troviamo occupazione alta ma prezzo medio compresso: la casa è piena, ma restano soldi sul tavolo. Partiamo da un'analisi gratuita sui tuoi numeri reali e ti mostriamo esattamente dove stai perdendo ricavi — poi decidi tu.",
  },
  {
    q: "Quanto costa e come si calcola?",
    a: "Dipende dal livello di servizio, dalla struttura e dai tuoi obiettivi. La provvigione si calcola sul valore lordo delle prenotazioni e si definisce insieme sul tuo caso reale. Si parte sempre da un'analisi gratuita e senza impegno: prima leggiamo i numeri, poi facciamo una proposta.",
  },
  {
    q: "In quanto tempo vedo dei risultati?",
    a: "L'analisi te la restituiamo subito. Sul prezzo i primi effetti si vedono già sulle finestre di prenotazione successive, ma il revenue management è un lavoro di stagione: si costruisce e si misura mese dopo mese, con report chiari alla mano.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="section-faq" className="bg-white py-24 md:py-32">
    <div className="mx-auto max-w-3xl px-6 md:px-12">
      <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={viewportOnce} className="mb-12 text-center">
        <motion.p variants={fadeUp} className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-gold">
          FAQ
        </motion.p>
        <motion.h2 variants={fadeUp} className="font-display text-4xl font-medium tracking-tight text-navy sm:text-5xl">
          Domande frequenti
        </motion.h2>
      </motion.div>

      <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce}>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-navy/10">
              <AccordionTrigger className="py-6 text-left font-display text-lg font-medium text-navy hover:text-gold hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-text-muted">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
